import React from 'react'
import {
  TooltipRoot,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface TooltipProps {
  content: string | React.ReactNode
  children: React.ReactNode
  align?: 'center' | 'end' | 'start'
  className?: string
}

const Tooltip = React.forwardRef<HTMLElement, TooltipProps>(
  ({ content, children, align = 'center', className }, ref) => {
    return (
      <div ref={ref as React.RefObject<HTMLDivElement>} className="inline-flex items-center">
        <TooltipProvider delayDuration={100}>
          <TooltipRoot>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent
              align={align}
              className={cn("px-3 py-2 text-sm text-black bg-white rounded-lg border border-gray-200 shadow-lg", className)}
            >
              {content}
            </TooltipContent>
          </TooltipRoot>
        </TooltipProvider>
      </div>
    )
  }
)

export default Tooltip
